import { useCallback, useEffect, useState } from 'react'
import { getUnderwriterDashboard } from 'actions/underwriterDashboard'

/**
 * Custom hook that loads the underwriter dashboard payload and exposes
 * range switching ('today' | 'week' | 'month'), loading + error state.
 */
export const useUnderwriterDashboard = (initialRange = 'week') => {
    const [range, setRange] = useState(initialRange)
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    const fetchData = useCallback(async (r) => {
        setLoading(true)
        setError(null)
        try {
            const apiRange = (r || range).toUpperCase()
            const res = await getUnderwriterDashboard(apiRange)()
            // request() may wrap responses in { response, ... } depending on flag — handle both shapes.
            setData(res?.response || res || null)
        } catch (e) {
            setError(e)
            setData(null)
        } finally {
            setLoading(false)
        }
    }, [range])

    useEffect(() => {
        fetchData(range)
    }, [range, fetchData])

    return {
        data,
        loading,
        error,
        range,
        setRange,
        refetch: () => fetchData(range)
    }
}
